import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';

import { USER_PERMISSIONS } from '@/config/const';

import PageNotFound from '@/views/page-not-found'

import AppContainer from '@/views/app-container'
import Analysis from '@/views/analysis/index.vue'
import MediaClipper from './views/media-clipper.vue';
import powerpointTemplate from '@/views/powerpoint_template.vue';
import ProjectsContainer from '@/views/analysis/coding-admin/coding-admin'
import ProjectsList from '@/views/analysis/coding-admin/list'
import Project from '@/views/analysis/coding-admin/project'
import ProjectConfiguration from '@/views/analysis/coding-admin/configuration'
import ProjectArticleGroup from '@/views/analysis/coding-admin/articles-group.vue';
import ProjectCodersList from '@/views/analysis/coding-admin/coders.vue';
import ProjectTags from '@/views/analysis/coding-admin/tags.vue';
import ProjectTagsUsageReport from '@/views/analysis/coding-admin/tags-usage-report.vue';
import ProjectAuthors from '@/views/analysis/coding-admin/authors.vue';
import ProjectSources from '@/views/analysis/coding-admin/sources.vue';
import Briefings from '@/views/analysis/coding-admin/briefings.vue';
// import ProjectArticles from '@/views/projects/articles'
import ProjectQueries from '@/views/analysis/coding-admin/queries.vue';
import ArticleAssignmentRules from '@/views/analysis/coding-admin/article-assignment-rules.vue';
import Editor from '@/views/analysis/coding-ui/editor';
import Queries from '@/views/coding-queries';
import Audits from '@/views/analysis/coding-admin/audits';

import UserPermissionsContainer from '@/views/analysis/coding-user-permissions/container'
import UserPermissionsList from '@/views/analysis/coding-user-permissions/list'
const ClientDataApi = () => import('@/views/analysis/client-data-api.vue')

import CodersContainer from '@/views/coders/container'
// import CodersList from '@/views/coders/list'
import CoderProfile from '@/views/coders/profile'

// Boolean Search
import GenericProjects from "@/views/generic-projects.vue";
import GenericProject from "@/views/generic-projects.vue";
import BooleanSearch from '@/views/boolean-search.vue'
import BooleanQueriesList from '@/views/boolean-search/queries-list.vue'
import BooleanGroupsList from '@/views/boolean-search/groups-list.vue'
import BooleanTagsList from '@/views/boolean-search/tags-searches-list.vue'
import BooleanSearchCreateQuery from '@/views/boolean-search/create-query.vue'
import BooleanSearchEditQuery from '@/views/boolean-search/edit-query.vue'
import BooleanSearchCreateGroup from '@/views/boolean-search/create-group.vue'
import BooleanSearchEditGroup from '@/views/boolean-search/edit-group.vue'
import BooleanSearchCreateTag from '@/views/boolean-search/create-tag-search.vue'
import BooleanSearchEditTag from '@/views/boolean-search/edit-tag-search.vue'
import ArticleTracker from '@/views/article-tracker.vue'
import Istarshine from '@/views/istarshine.vue'
import IstarshineView from '@/views/istarshine/istarshine-view.vue'
import BacksearchView from '@/views/istarshine/backsearch-view.vue'
import BacksearchCreate from '@/views/istarshine/backsearch-create.vue'

// Query Rules
const queryRulesProject = () => import('@/views/query-rules-project.vue')
const QueryRules = () => import('@/views/query-rules/query-rules.vue')
const CreateQueryRule = () => import('@/views/query-rules/create-rules.vue')
const EdiQueryRule = () => import('@/views/query-rules/edit-rules.vue')

// Outlets
const CreateOutlet = () => import('@/views/outlets/create-outlets.vue')
const EditOutlet = () => import('@/views/outlets/edit-outlets.vue')
const CbsAuto = () => import('@/views/outlets/cbs-auto.vue')

// Twitter Volume / Back Search
const TwitterSearchVolume = () => import('@/views/twitter-search-volume.vue');

const Relevancy = () => import('@/views/relevancy-ui.vue');
const CarmaAI = () => import('@/views/carma-ai.vue');
const CarmaAiGeoProjects = () => import('@/views/carma-ai/geo/projects.vue');
const CarmaAiGeoDashboardList = () => import('@/views/carma-ai/projects/geo/list.vue');
const CarmaAiProjectGeo = () => import('@/views/carma-ai/projects/geo/index.vue');
const CarmaAiGeoAudit = () => import('@/views/carma-ai/projects/geo/audit.vue');


const WhatsappContacts = () => import('./views/whatsapp/contacts.vue')
const WhatsappContactLists = () => import('./views/whatsapp/contact-lists.vue');
const WhatsappContact = () => import('./views/whatsapp/contact.vue');
const WhatsappContactList = () => import('./views/whatsapp/contact-list.vue');
const CreateWhatsappContactList = () => import('./views/whatsapp/create-contact-list.vue');
const NewWhatsappContact = () => import ('./views/whatsapp/contact-new.vue');
const WhatsappContactListAddContact = () => import('./views/whatsapp/contact-list-add-contact.vue');

const CarmaAppContacts = () => import('./views/mobile-app/contacts.vue')
const CarmaAppContactDetails = () => import ('./views/mobile-app/contact-details.vue')
const CarmaAppContactLists = () => import ('./views/mobile-app/contact-lists.vue')
const CarmaAppContactList = () => import ('./views/mobile-app/contact-list.vue')
const CreateCarmaAppContactList = () => import ('./views/mobile-app/create-contact-list.vue')

const UsersList = () => import('@/views/users/list.vue');
const InsightUsersList = () => import('@/views/insight-users/list.vue');
const BodhiPasswordReset = () => import('@/views/bodhi-password-reset.vue');
const BodhiForgotPassword = () => import('@/views/bodhi-forgot-password.vue');
const BodhiProfilePassword = () => import('@/views/bodhi-profile-password.vue');


const AclList = () => import('@/views/acl/list.vue');

// Manual Uploads
const OnlineIngest = () => import('@/views/manual-uploads/online-ingest.vue');
const PrintIngest = () => import('@/views/manual-uploads/print-ingest.vue');
const ManageUploads = () => import('@/views/manual-uploads/manage.vue');
const ManageDetail = () => import('@/views/manual-uploads/manage-detail.vue');

const InfluencerGroups = () => import('./components/influencer-groups/ProjectInfluencersGroups.vue');
const InfluencersGroupsLanding = () => import('./components/influencer-groups/GroupsLanding.vue');
const InfluencerGroupDetail = () => import('./components/influencer-groups/InfluencerGroupEdit.vue');
// const InfluencerDetails = () => import('./components/influencer-groups/InfluencerDetails.vue');
const Influencers = () => import('./components/influencer-groups/tabs/InfluencersTab.vue');

const CountrySubscription = () => import('./components/country-subscription/CountrySubscription.vue');
// Rails serves the same Vue shell for these paths (project_code#vue_sign_in),
// so the sign-in flow lives here rather than in Devise views.
const SignIn = () => import('@/views/auth/sign-in.vue');

const CarmaAiProjects = () => import('@/views/carma-ai/projects/index.vue');
const CarmaAiStoriesAdmin = () => import('@/views/carma-ai/admin/index.vue');
const CarmaAiStoriesAdminBackfills = () => import('@/views/carma-ai/admin/backfills.vue');
const CarmaAiStoriesAdminPrompts = () => import('@/views/carma-ai/admin/prompts.vue');
const CarmaAiProjectStories = () => import('@/views/carma-ai/projects/stories/index.vue');
const CarmaAiProjectStoriesOverview = () => import('@/views/carma-ai/projects/stories/overview.vue');
const CarmaAiProjectStoriesPromptStudio = () => import('@/views/carma-ai/projects/stories/prompt-studio.vue');
const CarmaAiProjectStoryBackfills = () => import('@/views/carma-ai/projects/stories/backfills.vue');
const CarmaAiProjectStoryPrompts = () => import('@/views/carma-ai/projects/stories/prompts.vue');
const CarmaAiProjectStoryAudits = () => import('@/views/carma-ai/projects/stories/audits.vue');

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function push(location) {
    return originalReplace.call(this, location).catch(err => err)
};

Vue.use(Router);

const routes = {
    acl: [
        {
            path: 'acl',
            name: 'acl',
            component: AclList,
        }
    ],
    analysis: [
        {
            path: 'analysis',
            name: "analysis",
            component: Analysis,
            children: [
                {
                    path: 'projects',
                    component: ProjectsContainer,
                    name: 'analysis-projects',
                    children: [
                        {
                            path: '',
                            name: 'analysis-projects-',
                            component: ProjectsList
                        },
                        {
                            path: ':project_uid',
                            component: Project,
                            name: 'project'
                        },
                        {
                            path: ':project_uid/configuration',
                            name: "analysis-projects--project_uid-configuration",
                            component: ProjectConfiguration,
                            meta: {
                                permissions: { name: USER_PERMISSIONS.EDIT_PROJECT_SETUP, level: true }
                            }
                        },
                        {
                            path: ':project_uid/groups',
                            name: "analysis-projects--project_uid-groups",
                            component: ProjectArticleGroup,
                            meta: {
                                // permissions: { name: USER_PERMISSIONS.VIEW_GROUPS_SCREENS, level: true }
                            }
                        },
                        {
                            path: ':project_uid/groups/:group_id/articles',
                            name: "group-articles",
                            component: Project,
                            meta: {
                                // permissions: { name: USER_PERMISSIONS.VIEW_GROUPS_SCREENS, level: true }
                            }
                        },
                        {
                            path: ':project_uid/authors',
                            name: "analysis-projects--project_uid-authors",
                            component: ProjectAuthors,
                            meta: {
                                // permissions: { name: USER_PERMISSIONS.VIEW_GROUPS_SCREENS, level: true }
                            }
                        },
                        {
                            path: ':project_uid/authors/:author_id/articles',
                            name: "author-articles",
                            component: Project,
                            meta: {
                                // permissions: { name: USER_PERMISSIONS.VIEW_GROUPS_SCREENS, level: true }
                            }
                        },
                        {
                            path: ':project_uid/files',
                            name: "analysis-projects--project_uid-files",
                            component: Briefings,
                            props: { role: ['code_editor'] }
                        },
                        {
                            path: ':project_uid/coders',
                            name: "analysis-projects--project_uid-coders",
                            component: ProjectCodersList,
                            meta: {
                                permissions: { name: USER_PERMISSIONS.VIEW_CODERS_LIST, level: true }
                            }
                        },
                        {
                            path: ':project_uid/coders/:coder_id/articles',
                            name: "coder-articles",
                            component: Project,
                            meta: {
                                // permissions: { name: USER_PERMISSIONS.VIEW_GROUPS_SCREENS, level: true }
                            }
                        },
                        {
                            path: ':project_uid/tags',
                            name: "analysis-projects--project_uid-tags",
                            component: ProjectTags,
                            meta: {
                                permissions: { name: USER_PERMISSIONS.VIEW_GROUPS_SCREENS, level: true }
                            }
                        },
                        {
                            path: ':project_uid/tags/usage-report',
                            name: "analysis-projects--project_uid-tags-usage-report",
                            component: ProjectTagsUsageReport,
                            meta: {
                                permissions: { name: USER_PERMISSIONS.VIEW_GROUPS_SCREENS, level: true }
                            }
                        },
                        {
                            path: ':project_uid/tags/:tag_id/articles',
                            name: "tag-articles",
                            component: Project,
                            meta: {
                                // permissions: { name: USER_PERMISSIONS.VIEW_GROUPS_SCREENS, level: true }
                            }
                        },
                        {
                            path: ':project_uid/organizations/:organization_id/articles',
                            name: "organization-articles",
                            component: Project,
                            meta: {
                                // permissions: { name: USER_PERMISSIONS.VIEW_GROUPS_SCREENS, level: true }
                            }
                        },
                        // todo: what are the required permissions to view sources
                        // if any, update the main-header.vue file as well (router-link)
                        {
                            path: ':project_uid/sources',
                            name: "analysis-projects--project_uid-sources",
                            component: ProjectSources,
                            meta: {
                                // permissions: { name: USER_PERMISSIONS.VIEW_GROUPS_SCREENS, level: true }
                            }
                        },
                        {
                            path: ':project_uid/rules',
                            name: "analysis-projects--project_uid-rules",
                            component: queryRulesProject,
                            props: true,
                            children: [
                                {
                                    path: '',
                                    name: "analysis-projects--project_uid-rules-",
                                    component: QueryRules,
                                    props: true,
                                    meta: { page_type: 'display' }
                                },
                            ],
                            meta: {
                                permissions: { name: USER_PERMISSIONS.VIEW_GROUPS_SCREENS, level: true }
                            }
                                
                        },
                        {
                            path: ':project_uid/sources/:source_id/articles',
                            name: "source-articles",
                            component: Project,
                            meta: {
                                // permissions: { name: USER_PERMISSIONS.VIEW_GROUPS_SCREENS, level: true }
                            }
                        },
                        {
                            path: ':project_uid/queries',
                            name: "analysis-projects--project_uid-queries",
                            component: ProjectQueries,
                            meta: {
                              permissions: { name: USER_PERMISSIONS.VIEW_GROUPS_SCREENS, level: true }
                            }
                        },
                        {
                            path: ':project_uid/autoassign',
                            name: "analysis-projects--project_uid-autoassign",
                            component: ArticleAssignmentRules,
                            meta: {
                                permissions: { name: USER_PERMISSIONS.VIEW_GROUPS_SCREENS, level: true }
                            }
                        },
                        {
                            path: ':project_uid/audits',
                            name: "analysis-projects--project_uid-audits",
                            component: Audits,
                            props: { roles: ['code_admin'] }
                        }
                    ]
                }
            ]
        },
        {
            path: 'analysis/user-permissions',
            name: "analysis-user-permissions",
            component: UserPermissionsContainer,
            props: { roles: ['code_admin'] },
            children: [
                {
                    path: '',
                    name: "analysis-user-permissions-",
                    component: UserPermissionsList
                }
            ]
        },
        {
            path: 'analysis/client-data-api',
            name: "analysis-client-data-api-",
            component: ClientDataApi,
            meta: {
                acl: { group: 'client_data_api', actions: ['view', 'manage'] }
            }
        },
        {
            path: 'analysis/coders',
            name: "analysis-coders",
            component: CodersContainer,
            children: [
                // '': CodersList,
                {
                    path: ':coder_id',
                    name: "analysis-coders--coder_id",
                    component: CoderProfile,
                    meta: {
                        permissions: { name: USER_PERMISSIONS.VIEW_CODERS_LIST, level: true }
                    }
                }
            ]
        },
        {
            path: 'analysis/editor/:project_id/:article_id',
            component: Editor,
            meta: {
                permissions: { name: USER_PERMISSIONS.VIEW_CODING_UI, level: true },
                navigation: false,
                editor: true
            }
        },
        {
            path: 'analysis/queries/:project_id/:query_id?',
            component: Queries,
            meta: {
                // permissions: { name: USER_PERMISSIONS.CODER_HOME_SCREEN, level: true },
                navigation: false,
            }
        },
        {
            path: 'analysis/:project_uid/rules',
            component: queryRulesProject,
            props: true,
            children: [
                {
                    path: 'new',
                    component: CreateQueryRule,
                    props: true,
                    meta: { page_type: 'create' }
                },
                {
                    path: ':query_rule_id',
                    component: EdiQueryRule,
                    props: true,
                    meta: { page_type: 'edit' }
                }
            ]
        }
    ],
    articleTracker: [
        {
            path: 'article-tracker',
            component: ArticleTracker,
            props: true,
        }
    ],
    mediaClipper: [
        {
            path: 'media-clipper/:article_id',
            component: MediaClipper
        }
    ],
    outlets: [
        {
            path: 'outlets/new',
            name: "Create Outlet",
            component: CreateOutlet,
            meta: { page_type: 'create' }
        },
        {
            path: 'outlets/:id/edit',
            name: "Edit Outlet",
            component: EditOutlet,
            props: true,
            meta: { page_type: 'edit' }
        },
        {
            path: 'outlets/:id/cbs_auto',
            name: "CBS Auto Configuration",
            component: CbsAuto,
            props: true,
            meta: { page_type: 'cbs_auto' }
        }
    ],
    influencerGroups: [
        {
            path: 'influencer_groups',
            name: 'influencer-groups',
            component: InfluencersGroupsLanding,
            props: true,
        },
        {
            path: 'influencer_groups/new',
            name: 'influencer-group-create',
            component: InfluencerGroupDetail,
            meta: { page_type: 'create' }
        },
        {
            path: 'influencer_groups/:id',
            name: 'influencer-groups-detail',
            component: InfluencerGroupDetail,
            props: true
        },
        {
            path: 'influencers',
            name: 'influencers',
            component: Influencers,
            props: true,
            meta: { page_type: 'display' }
        },
        // TODO: for future use
        // {
        //     path: 'influencers/:influencerId',
        //     name: 'influencer-details',
        //     component: InfluencerDetails,
        //     props: true,
        //     meta: { page_type: 'display' }
        // },
        // {
        //     path: 'influencer_groups/:id/influencer/:influencerId',
        //     name: 'influencer-details',
        //     component: InfluencerDetails,
        //     props: true,
        //     meta: { page_type: 'display' }
        // }
    ],
    projects: [
        {
            path: 'clients/:client_id/projects',
            name: "clients--client_id-projects",
            component: GenericProjects,
            children: [
                {
                    path: ':project_id',
                    name: "clients--client_id-projects--project_id",
                    component: GenericProject,
                    children: [
                        {
                            path: 'searches',
                            name: "clients--client_id-projects--project_id-searches",
                            component: BooleanSearch,
                            props: true,
                            children: [
                                {
                                    path: 'create',
                                    name: "clients--client_id-projects--project_id-searches-create",
                                    component: BooleanSearchCreateQuery,
                                      meta: {
                                        isGroupType: false
                                      }
                                },
                                {
                                    path: 'group_library',
                                    name: "clients--client_id-projects--project_id-searches-group_library",
                                    component: BooleanGroupsList,
                                      meta: {
                                        isGroupType: true
                                      }
                                },
                                {
                                    path: 'group_library/create',
                                    name: "clients--client_id-projects--project_id-searches-group_library-create",
                                    component: BooleanSearchCreateGroup,
                                      meta: {
                                        isGroupType: true
                                      }
                                },
                                {
                                    path: 'group_library/:group_id',
                                    name: "clients--client_id-projects--project_id-searches-group_library--group_id",
                                    component: BooleanSearchEditGroup,
                                    props: true,
                                      meta: {
                                        isGroupType: true
                                      }
                                },
                                {
                                    path: ':search_id',
                                    name: "clients--client_id-projects--project_id-searches--search_id",
                                    component: BooleanSearchEditQuery,
                                    props: true,
                                    meta: {
                                        isGroupType: false
                                    }
                                },
                                {
                                    path: '',
                                    name: "clients--client_id-projects--project_id-searches-",
                                    component: BooleanQueriesList,
                                    meta: {
                                        isGroupType: false
                                    }
                                }
                            ]
                        },
                        {
                            path: 'tags',
                            name: "clients--client_id-projects--project_id-tags",
                            component: BooleanSearch,
                            props: true,
                            children: [
                                {
                                    path: '',
                                    name: "clients--client_id-projects--project_id-tags-",
                                    component: BooleanTagsList,
                                    meta: {
                                        isGroupType: false,
                                        isTagSearchType: true
                                    }
                                },
                                {
                                    path: 'create',
                                    name: "clients--client_id-projects--project_id-tags-create",
                                    component: BooleanSearchCreateTag,
                                    meta: {
                                        isGroupType: false,
                                        isTagSearchType: true
                                    }
                                },
                                {
                                    path: ':tagSearch_id',
                                    name: "clients--client_id-projects--project_id-tags--tagSearch_id",
                                    component: BooleanSearchEditTag,
                                    props: true,
                                    meta: {
                                        isGroupType: false,
                                        isTagSearchType: true
                                    }
                                }
                            ]
                        },
                        {
                            path: 'twitter-volume',
                            name: "clients--client_id-projects--project_id-twitter-volume",
                            component: TwitterSearchVolume,
                            props: true
                        },
                        {
                            path: 'relevancy',
                            name: "clients--client_id-projects--project_id-relevancy",
                            component: Relevancy,
                            props: true,
                            children: [
                                {
                                    path: ':relevancy_id',
                                    name: "clients--client_id-projects--project_id-relevancy--relevancy_id",
                                    component: Relevancy,
                                    props: true,
                                    meta: {
                                    }
                                }
                            ]
                        },
                        {
                            path: 'carma_ai',
                            name: "clients--client_id-projects--project_id-carma_ai",
                            component: CarmaAI,
                            props: true
                        },
                        {
                            path: 'influencer_groups',
                            name: "clients--client_id-projects--project_id-influencer_groups",
                            component: InfluencerGroups,
                            props: true
                        },
                        {
                            path: 'country_subscription',
                            name: "clients--client_id-projects--project_id-country_subscription",
                            component: CountrySubscription,
                            props: true
                        },
                        {
                            path: 'istarshine',
                            name: "clients--client_id-projects--project_id-istarshine",
                            component: Istarshine,
                            props: true,
                            children: [
                                {
                                    path: '',
                                    name: "clients--client_id-projects--project_id-istarshine-",
                                    component: IstarshineView
                                },
                                {
                                    path: 'backsearch',
                                    name: "clients--client_id-projects--project_id-istarshine-backsearch",
                                    component: BacksearchView
                                },
                                {
                                    path: 'backsearch/create',
                                    name: "clients--client_id-projects--project_id-istarshine-backsearch-create",
                                    component: BacksearchCreate
                                },
                                {
                                    path: 'backsearch/edit/:request_id',
                                    name: "clients--client_id-projects--project_id-istarshine-backsearch-edit",
                                    component: BacksearchCreate
                                }
                            ]
                        }
                    ]
                }
            ]
        },
    ],
    powerpointTemplate: [{
        path: 'powerpoint_template',
        component: powerpointTemplate,
        name: 'Powerpoint Template'
    }],
    whatsapp: [
        {
            path: 'whats_app',
            name: "whatsapp-contact-lists",
            component: WhatsappContactLists
        },
        {
            path: 'whats_app/contacts',
            name: "whatsapp-contacts",
            component: WhatsappContacts
        },
        {
            path: 'whats_app/contacts/new',
            name: "whatsapp-new-contact",
            component: NewWhatsappContact,
            props: true,
        },
        {
            path: 'whats_app/contacts/:id',
            name: "whatsapp-contact",
            component: WhatsappContact,
            props: true,
            meta: { page_type: 'edit' }
        },
        {
            path: 'whats_app/contact_lists',
            name: "whatsapp-contact-lists",
            component: WhatsappContactLists
        },
        {
            path: 'whats_app/contact_lists/new',
            name: "create-whatsapp-contact-list",
            component: CreateWhatsappContactList
        },
        {
            path: 'whats_app/contact_lists/:id',
            name: "whatsapp-contact-list",
            component: WhatsappContactList
        },
        {
            path: 'whats_app/contact_lists/:contact_list_id/contact/new',
            name: "whatsapp-contact-list-add-contact",
            component: WhatsappContactListAddContact
        }
    ],

    mobileApp: [
        {
            path: 'mobile_app/contacts',
            name: "mobile-app-contacts",
            component: CarmaAppContacts
        },
        {
            path: 'mobile_app/contact_details/:id',
            name: "mobile-app-contact-details",
            component: CarmaAppContactDetails
        },
        {
            path: 'mobile_app/contact_lists',
            name: "mobile-app-contact-lists",
            component: CarmaAppContactLists
        },
        {
            path: 'mobile_app/contact_lists/:id',
            name: "mobile-app-contact-list",
            component: CarmaAppContactList
        },
        {
            path: 'mobile_app/contact_lists/new',
            name: "create-mobile-app-contact-list",
            component: CreateCarmaAppContactList
        }
    ],
    
    users: [{
        path: 'users',
        name: 'users',
        component: UsersList
    }, {
        path: 'profile/password',
        name: 'bodhi-profile-password',
        component: BodhiProfilePassword,
    }],

    insightUsers: [{
        path: 'samsara_api/users',
        name: 'insight-users',
        component: InsightUsersList,
        props: { roles: ['admin', 'account_manager'] }
    }, {
        path: 'samsara_api/media_eye_users',
        name: 'media-eye-users',
        component: InsightUsersList,
        props: { roles: ['admin', 'account_manager'], mediaEye: true }
    }],

    carmaAi: [{
        path: 'ai/geo',
        name: 'carma-ai-geo-projects',
        component: CarmaAiGeoProjects,
        meta: {
            breadcrumb: 'carma_ai.geo.breadcrumb_projects',
            acl: [
                { group: 'carma_ai', action: 'manage' },
                { group: 'carma_ai', action: 'manage_geo_dashboard' },
            ],
        },
        children: [{
            path: ':project_id',
            name: 'carma-ai-geo-project',
            component: CarmaAiGeoDashboardList,
            props: true,
        }, {
            path: ':project_id/dashboards/new',
            name: 'carma-ai-geo-dashboard-new',
            component: CarmaAiProjectGeo,
            props: true,
        }, {
            path: ':project_id/dashboards/:dashboard_id/setup',
            name: 'carma-ai-geo-dashboard-setup',
            component: CarmaAiProjectGeo,
            props: true,
        }, {
            path: ':project_id/dashboards/:dashboard_id',
            redirect: function (to) {
                return {
                    name: 'carma-ai-geo-dashboard-setup',
                    params: to.params,
                    query: { step: 'review' },
                };
            },
        }, {
            path: ':project_id/dashboards/:dashboard_id/audit',
            name: 'carma-ai-geo-audit',
            component: CarmaAiGeoAudit,
            props: true,
        }],
    }, {
        path: 'ai/clients-dashboards/admin',
        name: 'carma-ai-stories-admin',
        component: CarmaAiStoriesAdmin,
        meta: {
            breadcrumb: 'carma_ai.stories.admin.breadcrumb',
            acl: { group: 'carma_ai', actions: ['manage_client_dashboard_stories'] },
        },
        children: [
            {
                path: '',
                redirect: { name: 'carma-ai-stories-admin-backfills' },
            },
            {
                path: 'backfills',
                name: 'carma-ai-stories-admin-backfills',
                component: CarmaAiStoriesAdminBackfills,
            },
            {
                path: 'prompts',
                name: 'carma-ai-stories-admin-prompts',
                component: CarmaAiStoriesAdminPrompts,
            },
        ],
    }, {
        path: 'ai/clients-dashboards',
        name: 'carma-ai-stories',
        component: CarmaAiProjects,
        meta: {
            breadcrumb: 'carma_ai.stories.breadcrumb_projects',
            acl: { group: 'carma_ai', actions: ['view_client_dashboard_stories', 'manage_client_dashboard_stories'] },
        },
        children: [{
            path: ':project_id',
            name: 'carma-ai-story',
            component: CarmaAiProjectStories,
            props: true,
            meta: {
                breadcrumb: 'carma_ai.stories.breadcrumb_wizard',
            },
            children: [
                {
                    path: 'overview',
                    name: 'carma-ai-story-overview',
                    component: CarmaAiProjectStoriesOverview,
                    props: true,
                },
                {
                    path: 'prompt-studio',
                    name: 'carma-ai-story-prompt-studio',
                    component: CarmaAiProjectStoriesPromptStudio,
                    props: true,
                },
                {
                    path: 'backfills',
                    name: 'carma-ai-story-backfills-project',
                    component: CarmaAiProjectStoryBackfills,
                    props: true,
                },
                {
                    path: 'prompts',
                    name: 'carma-ai-story-prompts',
                    component: CarmaAiProjectStoryPrompts,
                    props: true,
                },
                {
                    path: 'audits',
                    name: 'carma-ai-story-audits',
                    component: CarmaAiProjectStoryAudits,
                    props: true,
                    meta: {
                        acl: { group: 'carma_ai', actions: ['manage_client_dashboard_stories'] },
                    },
                },
            ],
        }],
    }],

    manualUploads: [{
        path: 'manual-uploads/online-ingest',
        name: 'manual-uploads-online-ingest',
        component: OnlineIngest
    }, {
        path: 'manual-uploads/print-ingest',
        name: 'manual-uploads-print-ingest',
        component: PrintIngest
    }, {
        path: 'manual-uploads/manage',
        name: 'manual-uploads-manage',
        component: ManageUploads
    }, {
        path: 'manual-uploads/manage/:id',
        name: 'manual-uploads-manage-detail',
        component: ManageDetail
    }]
};

const router = new Router({
    mode: 'history',
    base: '/',
    routes: [
        {
            path: '/users/sign_in',
            name: 'sign-in',
            component: SignIn,
            meta: { navigation: false }
        },
        {
            path: '/users/password/edit',
            name: 'bodhi-password-reset',
            component: BodhiPasswordReset,
            meta: { navigation: false }
        },
        {
            path: '/users/password/new',
            name: 'bodhi-forgot-password',
            component: BodhiForgotPassword,
            meta: { navigation: false }
        },
        {
            path: '',
            component: AppContainer,
            /*beforeEnter: (to, from, next) => {
                store.dispatch('user/getUserInfo').then(() => store.dispatch('acl/getPermissions').then(() => {console.log("YEAH");next();}));
            },*/
            children: [
                //...routes.home,
                ...routes.analysis,
                ...routes.projects,
                //...routes.notifications,
                ...routes.outlets,
                ...routes.whatsapp,
                ...routes.mobileApp,
                ...routes.articleTracker,
                ...routes.users,
                ...routes.insightUsers,
                ...routes.acl,
                ...routes.powerpointTemplate,
                ...routes.mediaClipper,
                ...routes.influencerGroups,
                ...routes.carmaAi,
                ...routes.manualUploads,
            ],
            meta: {
                requiresAuth: true
            }
        },
        { path: '*', component: PageNotFound, name: '404' }
    ]
});

/*
router.beforeRouteEnter((to, from, next) => {
    const withPermissions = to.matched.filter(record => typeof record.meta.permissions === "function");
    console.log("BEFORE", to.matched, "AFTER", withPermissions);
    console.log(JSON.stringify(store.state.acl.permissions));
    setTimeout(function() {
        console.log("AND NOW");
        console.log(JSON.stringify(store.state.acl.permissions));
    }, 5000);
    for (let i = 0, l = withPermissions.length; i < l; ++i) {
        console.log("RESULT FOR", withPermissions[i], withPermissions[i].meta.permissions());
    }
    next();
});
*/

const SESSION_PUBLIC_PATHS = new Set([
    '/users/sign_in',
    '/users/password/edit',
    '/users/password/new'
]);

router.beforeEach((to, from, next) => {
    setInsightAuth(to)

    // Keep session pages always reachable (even with stale local auth state or host-specific route matching).
    if (SESSION_PUBLIC_PATHS.has(to.path)) {
        next()
        return
    }

    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (store.getters.isLoggedIn) {
            next()
            return
        }

        window.location.replace(
            '/users/sign_in?return_to=' + encodeURIComponent(to.fullPath || '/')
        )
    }
    else if (to.matched.some(record => record.meta.redirectIfAuthenticated)) {
        if (store.getters.isLoggedIn) {
            next('/')
            return
        }
        next()
    }
    else {
        next()
    }
});

function setInsightAuth(to) {
    if((to.query.insight && (to.query.insight === true || to.query.insight === 'true')) && !store.state.isInsight) {
        if(to.query.session_token) store.commit('SET_INSIGHT_SESSION_TOKEN', to.query.session_token)
        store.commit('SET_INSIGHT_FLAG', true)
    }
    // if insight=false/undefined & store insightFlag set to true
    else if((!to.query.insight || to.query.insight === "false") && store.state.isInsight) {
        store.commit('SET_INSIGHT_FLAG', false)
        if(to.query.auth) store.commit('SET_INSIGHT_AUTH', null)
    }
}


// at the moment the home page is the  analysis page
export default router